import React, {useEffect, useState} from 'react'
import compose from 'recompose/compose'
import moment from 'moment'
import _ from 'lodash'
import {withI18n} from '../../hocs'
import PropTypes from 'prop-types'
import * as S from './styled'
import ActionDialog from '../action-dialog'
import {ChipCustom} from '../../atoms'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'

const ModalChangeTagsQuery = ({ open, handleClose, i18n, tagsTypes, currentTags, onSubmit }) => {
  const [date] = React.useState(new Date())

  const [tagsShown, setTagsShown] = useState({});
  const [tagsForSelect, setTagsForSelect] = useState([]);

  const getTagsToShow = () => {
    const tags = _.cloneDeep(currentTags)
    let tagsReduce = tags.reduce((accu, theTag) => {
      _.map(tagsTypes, (theTagType) => {
        if (theTag.name === theTagType.name) {
          accu[theTag.id] = theTag;
          accu[theTag.id].color = theTagType.color;
        }
      })
      return accu;
    }, {})
    setTagsShown(tagsReduce)
  }

  useEffect(() => {
    getTagsToShow()
  }, [currentTags])

  useEffect(() => {
    tagsTypes && getTagsForSelect();
  }, [tagsShown]);

  const onClickSubmit = (e) => {
    e && e.preventDefault()
    let tagIds = Object.keys(tagsShown);
    // Devuelve la petición del padre: ActionDialog mantiene el spinner hasta que responde
    return Promise.resolve(onSubmit(tagIds, moment(date).format('YYYY-MM-DD HH:mm:ss'))).then(() => setTagsShown([]))
  }

  const renderTags = () => {
    return (
      _.map(tagsShown, (theTagShown) => {
        return <ChipCustom key={theTagShown.id} targetId={theTagShown.id} onDelete={removeTags} label={theTagShown.name} color={theTagShown.color} margin="0" />
      }))
  }

  const removeTags = (e) => {
    const idTagToRemove = parseInt(e.currentTarget.getAttribute('targetid'));
    let newTags = {...tagsShown};
    delete newTags[idTagToRemove];
    setTagsShown(newTags)
  }

  const handleAddTag = (tag) => {
    const idTagToAdd = tag.id
    let tagToAdd = _.find(tagsTypes, {id: idTagToAdd});
    let newTags = {...tagsShown, [idTagToAdd]: tagToAdd};
    setTagsShown(newTags)
  }

  const getTagsForSelect = () => {
    let idsNotAvaible = Object.keys(tagsShown);
    let selectValues = tagsTypes;
    if (idsNotAvaible) {
      selectValues = tagsTypes.filter(theTagType => !idsNotAvaible.includes(theTagType.id.toString()));
    }
    setTagsForSelect(selectValues);
  }

  return (
    <ActionDialog
      open={open}
      title={i18n.modalChangeTags.title}
      onClose={handleClose}
      onConfirm={onClickSubmit}
      cancelLabel={i18n.dialog.decline}
      confirmLabel={i18n.update}
    >
      <S.Body>
        {/* El buscador siempre visible; cada etiqueta elegida se añade como chip debajo y el
            campo se vacía para elegir la siguiente */}
        <Autocomplete
          key={_.size(tagsShown)}
          options={tagsForSelect}
          value={null}
          openOnFocus
          blurOnSelect
          getOptionLabel={option => (option && option.name) || ''}
          noOptionsText={i18n.modalChangeTags.noOptions}
          onChange={(e, newValue) => newValue && handleAddTag(newValue)}
          renderInput={params => <TextField {...params} variant="outlined" placeholder={i18n.headerProfileButtons.changeTags} />}
        />
        <div className="tags">{renderTags()}</div>
      </S.Body>
    </ActionDialog>
  )
}

ModalChangeTagsQuery.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  i18n: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  tagsTypes: PropTypes.array,
  currentTags: PropTypes.array,
  module: PropTypes.string,
}

const enharce = compose(withI18n)

export default enharce(ModalChangeTagsQuery)
